<IziPage class="room-list-template">
  <IziGrid class="room-list-container">
    <IziCol xl="2" />
    <IziCol class="room-list" xl="7">
      <IziGird>
        <IziCol class="title">
          <h3>AMONG US</h3>
        </IziCol>
        <IziCol class="sub-title">
          <span>ROOM LIST</span>
        </IziCol>
        <IziCol class="search-room" xl="12">
          <IziGrid>
            <IziCol xl="8" />
            <IziCol xl="4">
              <IziInput
                icon="pi-search"
                iconPos="left"
                label="Enter Room ID or PIN code"
                v-model:value="keySearch"
              />
            </IziCol>
          </IziGrid>
        </IziCol>
        <IziCol class="table-room">
          <IziCard>
            <DataTable
              :value="rooms"
              v-model:selection="room"
              selectionMode="single"
              dataKey="roomId"
              @row-select="selectRoom(room)"
            >
              <template #header>
                <IziGrid>
                  <IziCol xl="2">ROOM ID</IziCol>
                  <IziCol xl="3">HOST</IziCol>
                  <IziCol xl="3">HOST LEVEL</IziCol>
                  <IziCol xl="2">MEMBERS</IziCol>
                  <IziCol xl="2">STATUS</IziCol>
                </IziGrid>
              </template>
              <Column field="roomId">
                <template #body="slotProps">
                  <RoomCard :room="slotProps.data" />
                </template>
              </Column>
            </DataTable>
          </IziCard>
        </IziCol>
      </IziGird>
    </IziCol>
    <IziCol xl="3">
      <Leaderboard title="LEADERBOARD" />
    </IziCol>
  </IziGrid>  
</IziPage>